/**
 * @file 提交评分 api
 * @author FengGuang(fengguang01@baidu.com)
 */

import request from 'superagent';
import baseRequest from '../baseApi';

export const fetchSubmitRate = (value: number): Promise<request.Response> => {
    const docInfo = (window as any).docInfo || {
        lang: '',
        version: ''
    };

    return baseRequest(
        request.post('/platform/usercase/send')
            .query({type: 8})
            .send({
                path: window.location.pathname,
                version: docInfo.version,
                lang: docInfo.lang,
                score: value
            })
    );
};
